import React, { FC } from 'react';
import { Route, Router, Switch, useHistory } from 'react-router';

import { HtmlReport } from 'src/apps/mobile-common/pages/html-report/HtmlReport';
import { useMobileSdkTestDetailsQuery } from 'src/apps/mobile-sdk/hooks/useMobileSdkTestDetailsQuery';
import { useSetMobileSdkBreadcrumbs } from 'src/apps/mobile-sdk/hooks/useSetMobileSdkBreadcrumbs';
import { DashboardContainerMobileSDK } from 'src/apps/mobile-sdk/pages/dashboard-container/DashboardContainerMobileSDK';
import { MobileSdkSingleIssuePage } from 'src/apps/mobile-sdk/pages/single-issue/MobileSdkSingleIssuePage';
import { MobileSdkSingleTestPage } from 'src/apps/mobile-sdk/pages/single-test/MobileSdkSingleTestPage';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { ProductType } from 'src/common/interfaces/Tenant';
import { NotFound404Page } from 'src/common/pages/not-found-404-page/NotFound404Page';
import { Unauthorized403Page } from 'src/common/pages/unauthorized-403-page/Unauthorized403Page';
import { useUserTenant } from 'src/common/providers/userTenantProvider/UserTenantProvider';
import { getMsdkReportIdParam } from 'src/common/services/breadcrumbs/MsdkUrlService';
import { hasLicenseForProduct } from 'src/common/services/CommonDashboardService';
import { SessionViews } from 'src/common/types/WfaSessionViews';

const productType = ProductType.MOBILE_SDK;
const TEST_ID_KEY = ':testId';
const ISSUE_ID_KEY = ':issueId';

const MobileSdkTestReportGate: FC = () => {
	const { tenant } = useUserTenant();
	const { location } = useHistory();
	const hasLicense = hasLicenseForProduct(tenant, productType);

	const sessionId = getMsdkReportIdParam(location);

	const testDetailsQuery = useMobileSdkTestDetailsQuery(sessionId);

	const { testName } = testDetailsQuery.data ?? {};

	useSetMobileSdkBreadcrumbs(sessionId, testName);

	return hasLicense ? <HtmlReport sessionId={sessionId} msdkReport /> : <Unauthorized403Page />;
};

export const MobileSdkRouter: FC = () => {
	const history = useHistory();

	return (
		<Router history={history}>
			<Switch>
				<Route
					exact
					path={RoutesHelper.getMobileSdkIssueInfoPath({
						testId: TEST_ID_KEY,
						issueId: ISSUE_ID_KEY
					})}
					component={MobileSdkSingleIssuePage}
				/>
				<Route
					exact
					path={RoutesHelper.getMobileSdkTestPath(TEST_ID_KEY, SessionViews.OVERVIEW)}
					render={() => <MobileSdkSingleTestPage viewId={SessionViews.OVERVIEW} />}
				/>
				<Route
					exact
					path={RoutesHelper.getMobileSdkTestPath(TEST_ID_KEY, SessionViews.SCANS)}
					render={() => <MobileSdkSingleTestPage viewId={SessionViews.SCANS} />}
				/>
				<Route
					exact
					path={RoutesHelper.getMobileSdkTestPath(TEST_ID_KEY, SessionViews.ALL_ISSUES)}
					render={() => <MobileSdkSingleTestPage viewId={SessionViews.ALL_ISSUES} />}
				/>
				<Route
					exact
					path={RoutesHelper.getMobileSdkTestRootPath(TEST_ID_KEY)}
					render={() => <MobileSdkSingleTestPage viewId={SessionViews.OVERVIEW} />}
				/>
				<Route
					exact
					path={RoutesHelper.getMobileSdkDashboardPath()}
					component={DashboardContainerMobileSDK}
				/>
				{/* todo: remove after Mobile SDK v1 platform removed */}
				<Route
					exact
					path={RoutesHelper.getMobileSdkTestReportPathname()}
					render={() => <MobileSdkTestReportGate />}
				/>
				<Route render={() => <NotFound404Page />} />
			</Switch>
		</Router>
	);
};
